import { createStore } from "vuex";
import { FILE_PATH } from "../config/environment";

export default createStore({
  state: {
    version: "5.8.0",
    isAuth: localStorage.getItem("Auth"),
    userName: localStorage.getItem("Uname"),
    userId: localStorage.getItem("Uid"),
    schoolName: localStorage.getItem("school"),
    showDash: JSON.parse(localStorage.getItem("ShowDash")),
    isTeacher: JSON.parse(localStorage.getItem("IsTeacher")),
    filePath: FILE_PATH,
  },
  mutations: {},
  actions: {},
  modules: {},
});
